import { Tag } from 'antd'

// Status colours for the maintenance procurement link lifecycle + the
// 3-way match invoice path. Centralised so every screen reads the
// same palette.
const COLOUR: Record<string, string> = {
  // Link lifecycle
  AWAITING_APPROVAL: 'default',
  AWAITING_PO:       'blue',
  AWAITING_GRN:      'gold',
  AWAITING_INVOICE:  'orange',
  COMPLETE:          'green',
  CANCELLED:         'red',
  // Invoice 3-way match
  MATCHED:           'green',
  VARIANCE_FOUND:    'orange',
  BLOCKED:           'red',
  OVERRIDE_APPROVED: 'volcano',
  POSTED:            'green',
  // Decision results
  STOCK_OK:          'green',
  PR_RAISED:         'blue',
  PR_EXISTS:         'gold',
  // Direct charge marker
  DIRECT_CHARGE:     'purple',
}

interface Props {
  status: string | null | undefined
  label?: string
}

export default function ProcurementStatusBadge({ status, label }: Props) {
  if (!status) return <span style={{ color: '#999' }}>—</span>
  const text = (label ?? status).replace(/_/g, ' ')
  return <Tag color={COLOUR[status] ?? 'default'}>{text}</Tag>
}
